/* eslint-disable no-var */
var evs = require('@rexxars/eventsource-polyfill')

module.exports =
  typeof window === 'undefined' || !window.EventSource
    ? // Use polyfill in non-browser/legacy environments
      evs.EventSource
    : // Use native EventSource when we can
      window.EventSource



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sanity/eventsource/browser.js
// module id = 149
// module chunks = 0